import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from "vue";

interface Props {
  addr: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DaumAddr',
  props: {
    addr: {}
  },
  emits: ["updateAddress"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const zoneCode = ref("");
const address01 = ref(props.addr);

const loadDaumPostcode = () => {
  return new Promise<void>((resolve) => {
    const script = document.createElement('script');
    script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => resolve();
    document.head.appendChild(script);
  });
};

const findAddress = async () => {
  if (!window.daum?.Postcode) {
    await loadDaumPostcode();
  }
  
  new window.daum.Postcode({
    //eslint-disable-next-line
    oncomplete: (data: any) => {
      zoneCode.value = data.zonecode;
      address01.value = data.address;

      emit("updateAddress", {
        address: address01.value,
      });
    },
  }).open();
};

onMounted(async () => {
  await loadDaumPostcode();
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, {
    onClick: findAddress,
    readonly: "",
    "prepend-inner-icon": "mdi-map-legend",
    variant: "outlined",
    label: "기관 주소",
    type: "text",
    modelValue: address01.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((address01).value = $event)),
    maxlength: "150",
    color: "indigo",
    autocomplete: "off"
  }, null, 8, ["modelValue"]))
}
}

})